// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__2jz5A","menu":"Menu_menu__h_LVz","menuFaq":"Menu_menuFaq__237Ww"};